import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AudioService } from '@app/audio/audio.service';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { ShopService } from '@app/shared/services/shop.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-premium-pass-start',
  templateUrl: './premium-pass-start.component.html',
  styleUrls: ['./premium-pass-start.component.scss'],
  standalone: true,
  imports: [ButtonComponent, AnimatedTimerComponent, SharedModule],
})
export class PremiumPassStartModalComponent implements OnInit {
  buttonText: string;
  event: LimitedTimeEvent;

  private readonly eventManager = inject(EventManager);
  private readonly audioService = inject(AudioService);
  private readonly translateService = inject(TranslateService);
  private readonly shopService = inject(ShopService);
  private readonly eventsRepo = inject(EventsRepository);
  protected readonly premiumPassStartModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.event = this.eventsRepo.getEventById(this.premiumPassStartModalData.properties.eventId);
    this.setButtonText();
  }

  openOffer(): void {
    this.audioService.playButtonAudio('functionality');
    this.closeModal();

    this.shopService.openOfferOrShop(this.premiumPassStartModalData?.properties?.activeskus[0]);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.premiumPassStartModalData.id, ModalType.Persisted, this.premiumPassStartModalData)
    );
  }

  private setButtonText(): void {
    const propertiesButtonText =
      this.premiumPassStartModalData.properties.buttonText[this.translateService.currentLang];

    this.buttonText = propertiesButtonText
      ? propertiesButtonText
      : this.translateService.instant('home.buttons.go-promo');
  }
}
